import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useDeleteBankMutation} from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

const DeleteBankModal = ({showDeleteBankModal, onHide, details}) => {

    const [validated, setValidated] = useState(false);

    const [
        deleteBank, // This is the mutation trigger
        {
            isLoading: isDeleting,
            isSuccess: deletedSuccessfully,
        }, // This is the destructured mutation result
    ] = useDeleteBankMutation()

    /* Close Modal on Successful Deletion */
    useEffect(() => {
        if (deletedSuccessfully) {
            cogoToast.success("Created 'Bank Deletion' Action Successfully")
            onHide();
        }
    }, [deletedSuccessfully]);

    /* Delete Bank */
    const onSubmit = e => {
        e.preventDefault();
        e.stopPropagation();

        deleteBank({ref: details.ref, meta: details, bankName: details.bankName});
    }

    return (
        <Modal
            show={showDeleteBankModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isDeleting ? "static" : true}
            keyboard={!isDeleting}
            onExited={_ => setValidated(false)}
        >
            <Form
                noValidate
                validated={validated}
                onSubmit={onSubmit}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Delete Bank
                    </Modal.Title>
                    <button type="button" className="close" onClick={onHide}>
                        <span aria-hidden="true" className="d-block">×</span>
                        <span className="sr-only">Close</span>
                    </button>
                </Modal.Header>

                <Modal.Body style={{maxHeight: "calc(100vh - 300px)", overflow: "auto"}}>
                    <p>{`Are you sure you want to delete ${details?.bankName}?`}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={onHide}
                        disabled={isDeleting}
                        className="btn btn-light btn-elevate px-4"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        disabled={isDeleting}
                        className="btn btn-danger btn-elevate px-4 ml-4"
                    >
                        Delete
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default DeleteBankModal;
